// https://enappd.com/blog/ionic-4-save-and-retrieve-data-locally-on-device/59/
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
// import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  APP_ID = 'SmartPOS';

  constructor(public storage: Storage) { }
  // set a key/value
  async set(key: string, value: any): Promise<any> {
    try {
      // Prefix with the App ID for uniqueness
      key = this.APP_ID + '_' + key;
      const result = await this.storage.set(key, value);
      // console.log('set string in storage: ' + result);
      return true;
    } catch (reason) {
        console.log(reason);
        // this.ga.trackException(reason, true);
        return false;
    }
  }

  // to get a key/value pair
  async get(key: string): Promise<any> {
    try {
      key = this.APP_ID + '_' + key;
      const result = await this.storage.get(key);
      // console.log('storageGET: ' + key + ': ' + result);
      if (result != null) {
        return result;
      }
      return null;
    } catch (reason) {
        console.log(reason);
        // this.ga.trackException(reason, true);
        return reason;
    }
  }
  // set a key/value object
  // tslint:disable-next-line:ban-types
  async setObject(key: string, object: Object): Promise<any> {
    try {
      key = this.APP_ID + '_' + key;
      const result = await this.storage.set(key, JSON.stringify(object));
      if (result != null) {
        return result;
      }
      return null;
    } catch (reason) {
        console.log(reason);
        // this.ga.trackException(reason, true);
        return reason;
    }
  }
  // get a key/value object
  async getObject(key: string): Promise<any> {
    try {
      key = this.APP_ID + '_' + key;
      const result = await this.storage.get(key);
      if (result != null) {
      return JSON.parse(result);
    }
      return null;
    } catch (reason) {
      console.log(reason);
      // this.ga.trackException(reason, true);
      return null;
    }
  }
  // remove a single key value:
  async remove(key: string): Promise<any> {
    key = this.APP_ID + '_' + key;
    this.storage.remove(key);
    return true;
  }
  //  delete all data from your application:
  async clear(): Promise<any> {
    this.storage.clear();
    return true;
  }
}
